import { createModel } from '@rematch/core';
import { RootModel } from 'models';
import markupService from 'services/markupService';
import { ElementTypeEnum, Markup } from './../domains/markupDomain';
import { INDUSTRY_AVG_ID } from './../domains/orgDomain';
import { baseReducers, BaseState } from './baseReducers';

interface IndustryAvgState extends BaseState {
  elementMarkupPaper: number | null;
  elementMarkupPress: number | null;
  elementMarkupSvc: number | null;
  elementMarkupSvcmat: number | null;
  elementMarkupShipping: number | null;
  elementMarkupParcel: number | null;
}

export const industryAvg = createModel<RootModel>()({
  state: {
    elementMarkupPaper: null,
    elementMarkupPress: null,
    elementMarkupSvc: null,
    elementMarkupSvcmat: null,
    elementMarkupShipping: null,
    elementMarkupParcel: null,
  } as IndustryAvgState,
  reducers: {
    ...baseReducers<IndustryAvgState>(),
  },
  effects: (dispatch) => {
    const { industryAvg } = dispatch;
    return {
      async loadElementMarkups(): Promise<void> {
        const markups = await markupService.getElementMarkups(INDUSTRY_AVG_ID);
        const findMarkup = (markups: Markup[], type: ElementTypeEnum) => {
          const m = (markups || []).find((m) => m?.elementType === type);
          if (!m) return null;
          else return m.markupRanges[0]?.markupPct;
        };
        industryAvg.setState({
          elementMarkupPaper: findMarkup(markups, ElementTypeEnum.PAPER),
          elementMarkupPress: findMarkup(markups, ElementTypeEnum.PRESS),
          elementMarkupSvc: findMarkup(markups, ElementTypeEnum.SVC),
          elementMarkupSvcmat: findMarkup(
            markups,
            ElementTypeEnum.SVC_MATERIAL
          ),
          elementMarkupShipping: findMarkup(markups, ElementTypeEnum.SHIPPING),
          elementMarkupParcel: findMarkup(markups, ElementTypeEnum.PARCEL),
        });
      },
    };
  },
});
